<template>
  <div class="flex items-center space-x-2" data-testid="progress-bar">
    <div
      class="rounded-full"
      :class="bgColor"
      :style="{
        width: `${scaledWidth}px`,
        height: `${height}px`,
        borderRadius: borderRadius,
      }"
      data-testid="bar"
    ></div>
    <span data-testid="value">{{ numberFormatter(value) }}</span>
  </div>
</template>

<script setup>
import { defineProps, computed } from "vue";
import { numberFormatter } from "@/util/formatter";

const props = defineProps({
  value: {
    type: Number,
    required: true,
  },
  maxValue: {
    type: Number,
    required: true,
  },
  maxWidth: {
    type: Number,
    default: 150,
  },
  bgColor: {
    type: String,
    default: "bg-[#B2D8D8]",
  },
  height: {
    type: Number,
    default: 8,
  },
  borderRadius: {
    type: String,
    default: "4px",
  },
});

const scaledWidth = computed(() => {
  const m1 = props.value / props.maxValue;
  const m2 = m1 * props.maxWidth;
  return m2 > props.maxWidth ? props.maxValue : m2;
});
</script>
